import script from "./orderManage.vue?vue&type=script&setup=true&lang=js"
export * from "./orderManage.vue?vue&type=script&setup=true&lang=js"

import "./orderManage.vue?vue&type=style&index=0&id=2b8d1706&lang=less"
import "./orderManage.vue?vue&type=style&index=1&id=2b8d1706&lang=less"

const __exports__ = script;

export default __exports__